"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UnsecureIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UnsecureIcon, _React$PureComponent);

  function UnsecureIcon() {
    _classCallCheck(this, UnsecureIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnsecureIcon).apply(this, arguments));
  }

  _createClass(UnsecureIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'unsecure-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M7.942,6.99354185 C8.186,7.24072433 8.186,7.64290237 7.942,7.89008484 C7.824,8.00861086 7.667,8.07445866 7.5,8.07445866 C7.333,8.07445866 7.176,8.00861086 7.058,7.89008484 L6,6.81828542 L4.942,7.89008484 C4.824,8.00861086 4.667,8.07445866 4.5,8.07445866 C4.333,8.07445866 4.176,8.00861086 4.058,7.89008484 C3.815,7.64290237 3.815,7.24072433 4.058,6.99354185 L5.116,5.92174243 L4.058,4.85095606 C3.815,4.60377358 3.815,4.20159554 4.058,3.95441307 C4.301,3.70925668 4.699,3.70925668 4.942,3.95441307 L6,5.02621249 L7.058,3.95441307 C7.301,3.70925668 7.699,3.70925668 7.942,3.95441307 C8.186,4.20159554 8.186,4.60377358 7.942,4.85095606 L6.884,5.92174243 L7.942,6.99354185 Z M10.057,1.48765354 L6.742,0.144358617 C6.265,-0.0481195391 5.734,-0.0481195391 5.256,0.144358617 L1.943,1.48765354 C1.374,1.71862733 1,2.27782702 1,2.89882234 L1,4.3727998 C1,7.22046347 2.474,9.85741421 4.884,11.3212612 L5.999,12 L7.115,11.3212612 C9.525,9.85741421 11,7.21945042 11,4.37178675 L11,2.89882234 C11,2.27782702 10.627,1.71862733 10.057,1.48765354 L10.057,1.48765354 Z"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return UnsecureIcon;
}(_react.default.PureComponent);

exports.default = UnsecureIcon;
UnsecureIcon.defaultProps = {
  color: 'inherit'
};
UnsecureIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};